export default {
  "content": "<path d=\"M1.5 1h14\" stroke=\"#ff00cb\" stroke-opacity=\".9\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "17",
    "height": "2",
    "viewBox": "0 0 17 2",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};